import { BackgroundRatio } from "@/services/bedrock/dtos/BackgroundAsset";

/** Width and height of each ratio name. Compatibility and retained area come from the server. */
export const RATIO_DIMENSIONS: Record<BackgroundRatio, { width: number; height: number }> = {
  square_1_1: { width: 1, height: 1 },
  portrait_4_5: { width: 4, height: 5 },
  portrait_9_16: { width: 9, height: 16 },
  landscape_4_3: { width: 4, height: 3 },
};

// Written out in full so Tailwind finds each class in the source.
const ASPECT_CLASSES: Record<BackgroundRatio, string> = {
  square_1_1: "aspect-square",
  portrait_4_5: "aspect-[4/5]",
  portrait_9_16: "aspect-[9/16]",
  landscape_4_3: "aspect-[4/3]",
};

export function aspectClass(ratio: BackgroundRatio): string {
  return ASPECT_CLASSES[ratio];
}
